import { ReactComponent as ShieldCheckEmpty } from '../../../assets/icons/shield-check-empty.svg'
import { ReactComponent as ShieldCheckFillPrimary } from '../../../assets/icons/shield-check-fill-primary.svg'
import { ReactComponent as Square } from '../../../assets/icons/square.svg'
import { ReactComponent as SquareSuccessFill } from '../../../assets/icons/square-success-fill.svg'
import { ReactComponent as IconIndeterminate } from '../../../assets/icons/indeterminate.svg'

import theme from '../base'

const switchInput = {
  MuiRadio: {
    defaultProps: {
      disableRipple: true,
      icon: <ShieldCheckEmpty />,
      checkedIcon: <ShieldCheckFillPrimary />,
      color: 'primary',
    },
    styleOverrides: {
      root: {
        width: theme.spacing(5),
        height: 'auto',
        marginLeft: 11, // Override MUI negative margin left
        marginTop: -1,
        padding: theme.spacing(1),
        paddingTop: theme.spacing(0),
        color: theme.palette.neutral.main,
      },
      colorPrimary: {
        // TODO: Cannot apply on `colorPrimary` because specificity
        '&.MuiRadio-colorPrimary:hover, &.MuiRadio-colorPrimary.Mui-checked:hover':
          {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
          },

        '&.MuiIconButton-root:active, &.MuiIconButton-root:focus-visible': {
          color: theme.palette.primary.dark,
        },

        '&.Mui-checked:not(.Mui-disabled) + .MuiFormControlLabel-label': {
          '& .radioAmount': {
            color: theme.palette.neutral.dark,
          },
        },

        '&.Mui-disabled': {
          color: theme.palette.neutral.lighter,

          '&.Mui-checked': {
            color: theme.palette.neutral.light,

            '& .shieldCheckFillPrimaryBackground': {
              fill: theme.palette.neutral.light,
            },
          },
        },
      },
    },
  },
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true,
      icon: <Square />,
      checkedIcon: <SquareSuccessFill />,
      indeterminateIcon: <IconIndeterminate />,
      color: 'primary',
    },
    styleOverrides: {
      root: {
        marginLeft: 11, // Override MUI negative margin left
        marginRight: 14,
        padding: theme.spacing(1),
        color: theme.palette.neutral.main,
        '& svg': {
          width: theme.spacing(3),
          height: theme.spacing(3),
        },
      },
      colorPrimary: {
        // TODO: Cannot apply on `colorPrimary` because specificity
        '&.MuiCheckbox-colorPrimary:hover, &.MuiCheckbox-colorPrimary.Mui-checked:hover':
          {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
          },

        '&.MuiIconButton-root:active, &.MuiIconButton-root:focus-visible': {
          color: theme.palette.primary.dark,
        },

        '&.Mui-disabled': {
          color: theme.palette.neutral.lighter,

          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: theme.palette.neutral.light,
          },
        },

        '&.MuiCheckbox-indeterminate': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
}

export default switchInput
